import { DEFAULT_WEIGHTS } from "./criteria.js";

const STORAGE_KEY = "pv.profiles_v1";

const DEFAULT_PROFILES = {
  active: "matthijs",
  profiles: {
    matthijs: {
      name: "Matthijs",
      emoji: "👨",
      weights: { ...DEFAULT_WEIGHTS },
      enforceVeto: true,
      retreatMode: false,
    },
    partner: {
      name: "Anna",
      emoji: "👩",
      weights: { ...DEFAULT_WEIGHTS },
      enforceVeto: true,
      retreatMode: false,
    },
  },
};

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_PROFILES;
    const obj = JSON.parse(raw);
    // Migrate / fill in missing
    return migrateNames({
      active: obj.active || "matthijs",
      profiles: {
        matthijs: { ...DEFAULT_PROFILES.profiles.matthijs, ...(obj.profiles?.matthijs || {}) },
        partner:  { ...DEFAULT_PROFILES.profiles.partner, ...(obj.profiles?.partner || {}) },
      },
    });
  } catch {
    return DEFAULT_PROFILES;
  }
}

function migrateNames(state) {
  if (state?.profiles?.partner?.name === "Partner") state.profiles.partner.name = "Anna";
  return state;
}

function save(state) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch {}
}

export function getProfiles() {
  return load();
}

// Overschrijf de lokale state met een (server-)versie en normaliseer.
export function replaceProfiles(remote) {
  if (!remote || !remote.profiles) return load();
  const next = migrateNames({
    active: remote.active || "matthijs",
    profiles: {
      matthijs: { ...DEFAULT_PROFILES.profiles.matthijs, ...(remote.profiles.matthijs || {}) },
      partner:  { ...DEFAULT_PROFILES.profiles.partner,  ...(remote.profiles.partner  || {}) },
    },
  });
  save(next);
  return next;
}

export function setActiveProfile(id) {
  const state = load();
  state.active = id;
  save(state);
  return state;
}

export function updateProfile(id, patch) {
  const state = load();
  if (!state.profiles[id]) return state;
  state.profiles[id] = { ...state.profiles[id], ...patch };
  save(state);
  return state;
}

export function setProfileName(id, name) {
  return updateProfile(id, { name });
}

// Consensus = average of two profiles
export function computeConsensus(state) {
  const a = state.profiles.matthijs.weights;
  const b = state.profiles.partner.weights;
  const w = {};
  for (const k of new Set([...Object.keys(a), ...Object.keys(b)])) {
    w[k] = Math.round(((a[k] || 0) + (b[k] || 0)) / 2);
  }
  return {
    weights: w,
    enforceVeto: state.profiles.matthijs.enforceVeto || state.profiles.partner.enforceVeto,
    retreatMode: state.profiles.matthijs.retreatMode && state.profiles.partner.retreatMode,
  };
}

// Per-criterium divergence — voor het tonen "hier zijn jullie het oneens"
export function computeDivergence(state) {
  const a = state.profiles.matthijs.weights;
  const b = state.profiles.partner.weights;
  const div = {};
  for (const k of new Set([...Object.keys(a), ...Object.keys(b)])) {
    div[k] = Math.abs((a[k] || 0) - (b[k] || 0));
  }
  return div;
}
